import { useEffect, useState } from "react";
import axios from "axios";
import { readUser } from "utils/session";

const FLEETVIEW_TRIGGERS = ["disabled", "timer", "timer_and_notification", "notification"];

export function webFleetview(access) {
  const row = access?.fleetview?.WEB;
  const trigger = FLEETVIEW_TRIGGERS.includes(row?.trigger) ? row.trigger : "disabled";
  const rate = Number(row?.rateSeconds);
  return {
    trigger,
    rateSeconds: Number.isFinite(rate) && rate >= 1 ? rate : 60,
  };
}

export function deriveAccess(user) {
  if (user?.access && typeof user.access === "object") return user.access;
  const accountType = user?.accountType || "";
  if (!accountType) return null;
  return {
    accountType,
    canManageUsers: accountType === "MASTER",
    canZoneBranches: accountType === "MASTER" || accountType === "ZONE",
    canEditGeofence: accountType === "MASTER" || accountType === "ZONE",
    canViewGeofence: true,
    canConfigure: true,
    canReports: true,
    canLiveTrack: true,
  };
}

export function rememberAccess(access) {
  const user = readUser() || {};
  const next = {
    ...user,
    access,
    accountType: access?.accountType || user.accountType,
  };
  localStorage.setItem("userInfo", JSON.stringify(next));
  return next;
}

export function useAccountAccess() {
  const [access, setAccess] = useState(() => deriveAccess(readUser()));

  useEffect(() => {
    let cancelled = false;
    const base = process.env.REACT_APP_API_BASE_URL || "";
    axios
      .get(`${base}/api/me`)
      .then((response) => {
        if (cancelled) return;
        const next = response.data?.access;
        if (next) {
          rememberAccess(next);
          setAccess(next);
        }
      })
      .catch(() => {
        if (!cancelled) setAccess(deriveAccess(readUser()));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return access;
}
